import { createTypes } from 'redux-action-types'
import api from '../api'

export const types = createTypes('fridge/tokens/',
  'DELETE'
)

export const remove = async (token) => {
  await api.delete(`tokens/${token.id}`)
  return {type: types.DELETE, data: token}
}



// WEBPACK FOOTER //
// ./app/actions/tokens.js